import * as React from 'react';
import { Icon, iconName } from '../../../designSystem/icons/Icons';
import styled from 'styled-components';
import { Flex } from '../../../designSystem/compositeComponents/FlexHelpers';
import { rawColors } from '../../../designSystem/colors/color';
import { useHistory } from 'react-router-dom';

type DashboardCardType = "ongoing" | "done" | "alert";
type cardColor = "default" | "white" | string;


type DashboardCardProps = {
    status?: DashboardCardType;
    backgroundIcon?: iconName;
    backgroundColor?: cardColor;
    shadow?: boolean;
    children: React.ReactNode;
    redirectTo?: string;
}

export function DashboardCard(props: DashboardCardProps ): JSX.Element {
    const history = useHistory();
    
    const handleClick = props.redirectTo ? () => history.push(props.redirectTo) : undefined;
    
    return (
    <DashboardCardStyled shadow={props.shadow} backgroundColor={props.backgroundColor} redirectTo={props.redirectTo} onClick={handleClick} >
            <Flex flexDirection="column" gap={8}>
                {props.status === "ongoing" && <Icon name="navigation_clock" size='medium' color={rawColors.blue.normal}/> }
                {props.status === "done" && <Icon name="status_ok" size='medium' color={rawColors.green.normal}/> }
                {props.status === "alert" && <Icon name="status_error" size='medium' color={rawColors.red.normal}/> }
                {props.backgroundIcon && <div className="backgroundIcon"><Icon name={props.backgroundIcon} size='large' color={rawColors.gray.normal} /></div>}
                {props.children}
            </Flex>
            
        </DashboardCardStyled>
    );
}


const DashboardCardStyled = styled.div<{ status?: DashboardCardType, shadow?: boolean, backgroundIcon?: React.ReactNode, backgroundColor?: string, redirectTo?: string }>`
    border: 1px solid #ccc;
    border-radius: 8px;
    padding: 16px;
    position: relative;

    background-color: ${props => props.backgroundColor ? props.backgroundColor : props.theme.colors.card.light.default.background};


    ${props => props.shadow && `
        box-shadow: 0px 4px 8px 0px rgba(0,0,0,0.25);
        -webkit-box-shadow: 0px 4px 8px 0px rgba(0,0,0,0.25);
        -moz-box-shadow: 0px 4px 8px 0px rgba(0,0,0,0.25);
    `}

    ${props => props.redirectTo && `
        &:hover {
            cursor: pointer;
            box-shadow: 0px 6px 12px 0px rgba(0,0,0,0.35);
            -webkit-box-shadow: 0px 6px 12px 0px rgba(0,0,0,0.35);
            -moz-box-shadow: 0px 6px 12px 0px rgba(0,0,0,0.35);
        }
    `}


    & .icon{
        position:absolute;
        top: 4px;
        right: 4px;
    }

    & .backgroundIcon .icon{
        opacity: 0.25;
        position:absolute;
        bottom: 4px;
        right: 4px;
        top:auto;
    }

    & h3 {
        margin: 0;
        font-size: 1.2em;
    }
`